<template>
  <div class="track-container" ref="componentFocusTarget">

    <div class="track-container__inner track-container--disclaimer">
      <h1>Disclaimer and Assumptions</h1>

      <h2>Disclaimer</h2>
      <p>The CSC Benchmark calculator is provided by Commonwealth Superannuation Corporation (CSC) ABN: 48 882 817 243 AFSL: 238069. RSEL: L0001397.</p>
      <p>The CSC Benchmark calculator indicates the average balance of scheme customers, based on the information that you provide and the stated assumptions. Changes to any of the assumptions, or the information that you provide, may have an effect on the results generated. The results generated by the CSC Benchmark calculator are estimates only and are not guaranteed. </p>
      <p>The CSC Benchmark calculator is not intended to be relied on for the purposes of making a decision in relation to a financial product. In making any decisions about your superannuation or your retirement, you should consider your own objectives, financial situation and needs, and you should not rely solely on the CSC Benchmark calculator. You should consider getting advice from a licensed financial advisor before making any financial decisions.</p>
      <p>By using this calculator, you consent to CSC using the personal information you provide to compare against the average account balance of members of the superannuation scheme based on the Age and Gender inputs you enter.  A full copy of our privacy policy as well as the privacy complaint process is available at <a href="https://www.csc.gov.au/privacy/" target="_blank">csc.gov.au/privacy/</a> </p>


      <h2>Assumptions</h2>
      
      <p v-if="scheme === 'PSSAP' || scheme === 'ADFSuper'">
        This calculator reflects the average account balance of members of the superannuation scheme on 30 June 2022 based on the Age and Gender inputs you entered.
      </p>
      <p v-else>
        This calculator reflects the average account balance of members of the superannuation scheme on 30 June 2022 based on the Age and Gender inputs you entered.
      </p>

      <p>
        The superannuation amounts are shown in today’s dollars. This does not consider any other superannuation accounts that you may hold or any other assets that you own.
      </p>

      <a href="#" @click="$router.go(-1)" class="button">Continue</a>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Welcome',
  methods: {
    track () {
      this.$ga.page('/disclaimer')
    }
  },
  computed: {
    ...mapGetters(['getScheme']),
    scheme: {
      get() {
        return this.getScheme;
      }
    }
  }
}
</script>